import { h, defineComponent, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { can_move_selected_objects } from '../../lattice';
import scale_svg from '../../../assets/img/SVG_icons/Top/advanced_operation/scale.svg';
import { img } from '@phi/components';
import { display_scale_modal } from '@phi/scale';
import ScaleTooltip from './ScaleTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const ScaleIcon = scale_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Scale';
        },

        disabled() {
            return !this.state.loaded
                || !(
                    this.many_vertices_or_others
                    || this.one_vertex_and_others
                )
                || !can_move_selected_objects();
        },

        one_vertex_and_others() {
            return this.state.selected_vertices_count === 1
                && (
                    this.state.selected_edges_count > 0
                    || this.state.selected_faces_count > 0
                );
        },

        many_vertices_or_others() {
            return this.state.selected_vertices_count > 1
                || this.state.selected_edges_count > 0
                || this.state.selected_faces_count > 0;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                display_scale_modal('');
        }
    },

    render() {
        return h(BarButton, {
            id: 'scale-button',
            wrapperId: 'scale-button-wrapper',
            tippy: 'bottom',
            disabled: this.disabled,
            active: false,
            selected: this.state.tut_stage === 5,
            onClick: this.onClick,
            help: 'scale_objects',
        }, {
            label: () => 'Scale',
            icon: () => this.coming_soon ? coming_soon(this.alt): img(scale_svg, this.alt),
            tooltip: ScaleTooltip,
        });
    },
});
